import { Action } from 'redux';
import { EnrollmentStateStructure } from '../../angular-elements/shared/interfaces/enrollmentStateStructure.interface';

export const ENROLLMENT_STATE_NAME = 'enrollment';
export class PayloadAction implements Action {
  type: string;
  enrollmentStateStructure?: EnrollmentStateStructure;
  effectiveDate?: string;
  coverageDate?: string;
  ctrlName?: string;
  whb?: boolean;
  hardStops?: string;
  partAEffectiveDate?: string;
}

const INITIAL_STATE: EnrollmentStateStructure = {
  medicareNumber: '',
  partAEffectiveDate: '',
  partBEffectiveDate: '',
  currentlyEnrolledMAOther: '',
  currentlyMedicaidRecipient: '',
  medicaidNumber: '',
  hmBlueShieldPlan: '',
  planName: '',
  employedStatus: '',
  willRetiredDate: '',
  spouseEmployedStatus: '',
  spouseRetiredDate: '',
  spouseHasRetiredDate: '',
  otherInsurance: '',
  activeGroupInsurance: false,
  veteranAdminCoverge: false,
  federalBlackLungCoverage: false,
  workersCompensationCoverage: false,
  retireCoverage: false,
  otherInsuranceDirectPayCoverage: false,
  supplementalCoverage: false,
  isMedicare: false,
  isMedicalWithPd: false,
  isDentalVision: false,
  isPd: false,
  isEmployer: false,
  isSpouseEmployer: false,
  isIndividual: false,
  employerName: '',
  employeeCount: '',
  employerInsuranceName: '',
  employerInsurancePolicyNo: '',
  employerInsuranceGroupNo: '',
  spouseEmployerName: '',
  spouseEmployeeCount: '',
  spouseEmployerInsuranceName: '',
  spouseEmployerInsurancePolicyNo: '',
  spouseEmployerInsuranceGroupNo: '',
  individualInsuranceName: '',
  individualInsurancePolicyNo: '',
  individualInsuranceGroupNo: '',
  effectiveDate: '',
  paymentType: '',
  billingFrequency: '',
  statementCheck: false,
  reviewLabel1: '',
  saveElectionAppIn: [],
  productData: {
    planId: '',
    planName: '',
    cmsPlanID: '',
    pbpId: '',
    segmentId: '',
    groupNo: '',
    newGroupNo: '',
    superProductId: '',
    monthlyPremium: null,
    planDetails: null
  },
  userType: '',
  userId: '',
  submissionChannel: '',
  applicant: '',
  requiredDocuments: {},
  gender: null,
  coverageDate: null,
  dob: null,
  macra: null,
  tobaccoUsage: null,
  whb: null,
  hardStops: null,
  memberIdNumber: '',
  mediGapMemberId: '',
  agreementId: '',
  uploadedDocumentIds: [],
  documentProvidedMethod: '',
  sendOutlineOfCoverageEmail: {}
};

export const SAVE_WHB_VALUE = 'SAVE_WHB_VALUE';
export const SAVE_ENROLLMENT_HARD_STOPS = 'SAVE_ENROLLMENT_HARD_STOPS';
export const LOAD_ENROLLMENT_INFO = 'LOAD_ENROLLMENT_INFO';
export const SAVE_EFFECTIVE_DATE = 'SAVE_EFFECTIVE_DATE';
export const SAVE_PARTA_EFFECTIVE_DATE = 'SAVE_PARTA_EFFECTIVE_DATE';
export const SAVE_COVERAGE_DATE = 'SAVE_COVERAGE_DATE';
export const MODIFY_REQUIRED_DOCUMENTS = 'MODIFY_REQUIRED_DOCUMENTS';
export const INIT_PAYLOAD = 'INIT_PAYLOAD';
export const RESET_CONTROL = 'RESET_CONTROL';
const RESET_STATE = 'RESET_STATE_Enrollment';

export function loadEnrollmentInfo(enrollment: EnrollmentStateStructure): PayloadAction {
  return {
    type: LOAD_ENROLLMENT_INFO,
    enrollmentStateStructure: enrollment
  };
}

export function saveEnrollmentWhb(whb: boolean): PayloadAction {
  return {
    type: SAVE_WHB_VALUE,
    whb
  };
}
export function saveEnrollmentHardStops(hardStops: string): PayloadAction {
  return {
    type: SAVE_ENROLLMENT_HARD_STOPS,
    hardStops
  };
}
export function saveEffectiveDate(effDate: string): PayloadAction {
  return {
    type: SAVE_EFFECTIVE_DATE,
    effectiveDate: effDate
  };
}
export function savePartAEffectiveDate(partADate: string): PayloadAction {
  return {
    type: SAVE_PARTA_EFFECTIVE_DATE,
    partAEffectiveDate: partADate
  };
}
export function saveCoverageDate(covDate: string): PayloadAction {
  return {
    type: SAVE_COVERAGE_DATE,
    coverageDate: covDate
  };
}
export function resetControl(controlName: string): PayloadAction {
  return {
    type: RESET_CONTROL,
    ctrlName: controlName
  };
}

export function modifyRequiredDocuments(requiredDocuments: any): PayloadAction {
  return {
    type: MODIFY_REQUIRED_DOCUMENTS,
    enrollmentStateStructure: requiredDocuments
  };
}

export function resetEnrollment(): PayloadAction {
  return { type: RESET_STATE };
}

export function enrollment(state: EnrollmentStateStructure = INITIAL_STATE, action: PayloadAction) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case MODIFY_REQUIRED_DOCUMENTS:
      copiedState.requiredDocuments = action.enrollmentStateStructure.requiredDocuments;
      break;
    case SAVE_COVERAGE_DATE:
      copiedState.coverageDate = action.coverageDate;
      return Object.assign({}, state, copiedState);
    case SAVE_WHB_VALUE:
      copiedState.whb = action.whb;
      return Object.assign({}, state, copiedState);
    case SAVE_ENROLLMENT_HARD_STOPS:
      copiedState.hardStops = action.hardStops;
      return Object.assign({}, state, copiedState);
    case SAVE_EFFECTIVE_DATE:
      copiedState.effectiveDate = action.effectiveDate;
      return Object.assign({}, state, copiedState);
    case SAVE_PARTA_EFFECTIVE_DATE:
      copiedState.partAEffectiveDate = action.partAEffectiveDate;
      return Object.assign({}, state, copiedState);
    case RESET_CONTROL:
      if (copiedState[action.ctrlName]) {
        copiedState[action.ctrlName] = '';
      }
      return Object.assign({}, state, copiedState);
    case LOAD_ENROLLMENT_INFO:
      copiedState.medicareNumber = action.enrollmentStateStructure.medicareNumber;
      copiedState.partAEffectiveDate = action.enrollmentStateStructure.partAEffectiveDate;
      copiedState.partBEffectiveDate = action.enrollmentStateStructure.partBEffectiveDate;
      copiedState.currentlyEnrolledMAOther = action.enrollmentStateStructure.currentlyEnrolledMAOther;
      copiedState.currentlyMedicaidRecipient = action.enrollmentStateStructure.currentlyMedicaidRecipient;
      copiedState.medicaidNumber = action.enrollmentStateStructure.medicaidNumber;
      copiedState.hmBlueShieldPlan = action.enrollmentStateStructure.hmBlueShieldPlan;
      copiedState.planName = action.enrollmentStateStructure.planName;
      copiedState.employedStatus = action.enrollmentStateStructure.employedStatus;
      copiedState.willRetiredDate = action.enrollmentStateStructure.willRetiredDate;
      copiedState.spouseEmployedStatus = action.enrollmentStateStructure.spouseEmployedStatus;
      copiedState.spouseRetiredDate = action.enrollmentStateStructure.spouseRetiredDate;
      copiedState.spouseHasRetiredDate = action.enrollmentStateStructure.spouseHasRetiredDate;
      copiedState.otherInsurance = action.enrollmentStateStructure.otherInsurance;
      copiedState.activeGroupInsurance = action.enrollmentStateStructure.activeGroupInsurance;
      copiedState.veteranAdminCoverge = action.enrollmentStateStructure.veteranAdminCoverge;
      copiedState.federalBlackLungCoverage = action.enrollmentStateStructure.federalBlackLungCoverage;
      copiedState.workersCompensationCoverage = action.enrollmentStateStructure.workersCompensationCoverage;
      copiedState.retireCoverage = action.enrollmentStateStructure.retireCoverage;
      copiedState.otherInsuranceDirectPayCoverage = action.enrollmentStateStructure.otherInsuranceDirectPayCoverage;
      copiedState.supplementalCoverage = action.enrollmentStateStructure.supplementalCoverage;
      copiedState.isMedicare = action.enrollmentStateStructure.isMedicare;
      copiedState.isMedicalWithPd = action.enrollmentStateStructure.isMedicalWithPd;
      copiedState.isDentalVision = action.enrollmentStateStructure.isDentalVision;
      copiedState.isPd = action.enrollmentStateStructure.isPd;
      copiedState.isEmployer = action.enrollmentStateStructure.isEmployer;
      copiedState.isSpouseEmployer = action.enrollmentStateStructure.isSpouseEmployer;
      copiedState.isIndividual = action.enrollmentStateStructure.isIndividual;
      copiedState.employerName = action.enrollmentStateStructure.employerName;
      copiedState.employeeCount = action.enrollmentStateStructure.employeeCount;
      copiedState.employerInsuranceName = action.enrollmentStateStructure.employerInsuranceName;
      copiedState.employerInsurancePolicyNo = action.enrollmentStateStructure.employerInsurancePolicyNo;
      copiedState.employerInsuranceGroupNo = action.enrollmentStateStructure.employerInsuranceGroupNo;
      copiedState.spouseEmployerName = action.enrollmentStateStructure.spouseEmployerName;
      copiedState.spouseEmployeeCount = action.enrollmentStateStructure.spouseEmployeeCount;
      copiedState.spouseEmployerInsuranceName = action.enrollmentStateStructure.spouseEmployerInsuranceName;
      copiedState.spouseEmployerInsurancePolicyNo = action.enrollmentStateStructure.spouseEmployerInsurancePolicyNo;
      copiedState.spouseEmployerInsuranceGroupNo = action.enrollmentStateStructure.spouseEmployerInsuranceGroupNo;
      copiedState.individualInsuranceName = action.enrollmentStateStructure.individualInsuranceName;
      copiedState.individualInsurancePolicyNo = action.enrollmentStateStructure.individualInsurancePolicyNo;
      copiedState.individualInsuranceGroupNo = action.enrollmentStateStructure.individualInsuranceGroupNo;
      copiedState.effectiveDate = action.enrollmentStateStructure.effectiveDate;
      copiedState.paymentType = action.enrollmentStateStructure.paymentType;
      copiedState.billingFrequency = action.enrollmentStateStructure.billingFrequency;
      copiedState.statementCheck = action.enrollmentStateStructure.statementCheck;
      copiedState.reviewLabel1 = action.enrollmentStateStructure.reviewLabel1;
      copiedState.saveElectionAppIn = action.enrollmentStateStructure.saveElectionAppIn;
      copiedState.productData = action.enrollmentStateStructure.productData;
      copiedState.userType = action.enrollmentStateStructure.userType;
      copiedState.userId = action.enrollmentStateStructure.userId;
      copiedState.submissionChannel = action.enrollmentStateStructure.submissionChannel;
      copiedState.applicant = action.enrollmentStateStructure.applicant;
      copiedState.requiredDocuments = action.enrollmentStateStructure.requiredDocuments;
      copiedState.gender = action.enrollmentStateStructure.gender;
      copiedState.coverageDate = action.enrollmentStateStructure.coverageDate;
      copiedState.dob = action.enrollmentStateStructure.dob;
      copiedState.macra = action.enrollmentStateStructure.macra;
      copiedState.whb = action.enrollmentStateStructure.whb;
      copiedState.hardStops = action.enrollmentStateStructure.hardStops;
      copiedState.tobaccoUsage = action.enrollmentStateStructure.tobaccoUsage;
      copiedState.memberIdNumber = action.enrollmentStateStructure.memberIdNumber;
      copiedState.mediGapMemberId = action.enrollmentStateStructure.mediGapMemberId;
      copiedState.agreementId = action.enrollmentStateStructure.agreementId;
      copiedState.uploadedDocumentIds = action.enrollmentStateStructure.uploadedDocumentIds;
      copiedState.documentProvidedMethod = action.enrollmentStateStructure.documentProvidedMethod;
      copiedState.sendOutlineOfCoverageEmail = action.enrollmentStateStructure.sendOutlineOfCoverageEmail;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    case INIT_PAYLOAD:
    default:
      return state;
  }
}

